import { useState } from "react";
import { Bookmark, Check } from "@fg/icons";
import { addSavedSearch, useSavedSearches } from "@/lib/savedSearches";

/** "Save this search": keeps the query under a name in the folder pane (Outlook search folders / Gmail saved searches). */
export function SaveSearchBar({ query }: { query: string }) {
    const saved = useSavedSearches();
    const [naming, setNaming] = useState(false);
    const [name, setName] = useState("");
    const already = saved.some((s) => s.query.toLowerCase() === query.trim().toLowerCase());

    const commit = () => {
        addSavedSearch(name || query, query);
        setNaming(false);
        setName("");
    };

    if (already) {
        return (
            <div className="flex shrink-0 items-center gap-1.5 border-b px-3 py-1.5 text-xs text-[var(--mail-text-2)]">
                <Check className="h-3.5 w-3.5" aria-hidden /> Saved. Find it under Saved searches.
            </div>
        );
    }
    return (
        <div className="flex shrink-0 items-center gap-2 border-b px-3 py-1.5">
            {naming ? (
                <>
                    <input
                        autoFocus
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") commit();
                            if (e.key === "Escape") setNaming(false);
                        }}
                        placeholder="Name this search"
                        aria-label="Name for the saved search"
                        className="h-7 min-w-0 flex-1 rounded border border-[var(--mail-line-strong)] bg-background px-2 text-xs outline-none focus:ring-2 focus:ring-ring"
                    />
                    <button type="button" onClick={commit} className="h-7 rounded bg-primary px-2.5 text-xs font-medium text-primary-foreground">Save</button>
                    <button type="button" onClick={() => setNaming(false)} className="h-7 rounded px-2 text-xs hover:bg-[var(--mail-hover)]">Cancel</button>
                </>
            ) : (
                <button
                    type="button"
                    onClick={() => { setName(query.length > 40 ? query.slice(0, 40) : query); setNaming(true); }}
                    className="flex h-7 items-center gap-1.5 rounded px-2 text-xs font-medium text-primary hover:bg-[var(--mail-hover)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
                >
                    <Bookmark className="h-3.5 w-3.5" aria-hidden /> Save this search
                </button>
            )}
        </div>
    );
}
